import { EpicIcons } from "@constellation-academy/epic-ui";
import { Toast } from "primereact/toast";
import React, { useContext, useRef } from "react";
import { useFragment, useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { deleteVideoSourceButton_DeleteVimeoVideoSourceMutation } from "@relay/deleteVideoSourceButton_DeleteVimeoVideoSourceMutation.graphql";
import { deleteVideoSourceButton_Vimeo_VimeoVideoSourceFragment$key } from "@relay/deleteVideoSourceButton_Vimeo_VimeoVideoSourceFragment.graphql";
import {
	DELETE_VIMEO_VIDEO_SOURCE_MUTATION,
	VIMEO_VIMEO_VIDEO_SOURCE_FRAGMENT,
} from "./delete-video-source-button.graphql";
import { DeleteVideoSourceButtonProps } from "./delete-video-source-button.types";
import { Button, ButtonVariant } from "../../../../components/button";
import { VideoSourcesScreenContext } from "../../video-sources.context";

export const DeleteVideoSourceButton = ({
	videoSourceFragmentRef,
	onRefresh,
}: DeleteVideoSourceButtonProps) => {
	const { t } = useTranslation("common");
	const toast = useRef<Toast>(null);

	const videoSource = useFragment<deleteVideoSourceButton_Vimeo_VimeoVideoSourceFragment$key>(
		VIMEO_VIMEO_VIDEO_SOURCE_FRAGMENT,
		videoSourceFragmentRef,
	);

	const { connectionId } = useContext(VideoSourcesScreenContext);
	const [deleteVideoSource, isDeletingVideoSource] =
		useMutation<deleteVideoSourceButton_DeleteVimeoVideoSourceMutation>(
			DELETE_VIMEO_VIDEO_SOURCE_MUTATION,
		);

	const handleDeleteVideoSource = () =>
		deleteVideoSource({
			variables: {
				input: {
					ids: [videoSource.id],
				},
				connections: [connectionId],
			},
			onCompleted: () => {
				toast.current?.show({
					severity: "success",
					life: 3000,
					summary: t("videoSources.deletedSummary"),
					detail: t("videoSources.deletedDetail"),
				});
				onRefresh();
			},
		});

	return (
		<>
			<Toast ref={toast} />
			<Button
				icon={EpicIcons.TRASH}
				variant={ButtonVariant.Error}
				tooltip={t("videoSources.deleteTooltip")}
				loading={isDeletingVideoSource}
				disabled={isDeletingVideoSource || videoSource.isDefault}
				onClick={handleDeleteVideoSource}
			/>
		</>
	);
};
